export class Operator {
  operatorUuid: string = null;
  name: string = null;
  dedicatedFleet: boolean = null;

  getOperatorUuid(): string {
    return this.operatorUuid;
  }

  setOperatorUuid(operatorUuid: string): Operator {
    this.operatorUuid = operatorUuid;

    return this;
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): Operator {
    this.name = name;

    return this;
  }

  getDedicatedFleet(): boolean {
    return this.dedicatedFleet;
  }

  setDedicatedFleet(value: boolean): Operator {
    this.dedicatedFleet = value;
    return this;
  }

  equals(o1: Operator): boolean {

    if (!o1) {
      return false;
    }

    return this.operatorUuid === o1.operatorUuid;
  }
}
